import { useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { CustomerAuthProvider } from "@/context/CustomerAuth";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Categories } from "@/components/Categories";
import { ProductCatalog } from "@/components/ProductCatalog";
import { VisitUs } from "@/components/VisitUs";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import AdminPage from "@/pages/AdminPage";
import AccountPage from "@/pages/AccountPage";
import AuthCallback from "@/pages/AuthCallback";
import AuthPage from "@/pages/AuthPage";
import OrderSuccess from "@/pages/OrderSuccess";
import ResetPassword from "@/pages/ResetPassword";
import ProductDetail from "@/pages/ProductDetail";

const Home = () => {
  const [category, setCategory] = useState("All");

  const selectCategory = useCallback((c) => {
    setCategory(c);
    document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <div className="noise-overlay" />
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Categories onSelect={selectCategory} />
      <ProductCatalog category={category} setCategory={setCategory} />
      <VisitUs />
      <Footer />
    </div>
  );
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/product/:productId" element={<ProductDetail />} />
      <Route path="/order-success/:orderId" element={<OrderSuccess />} />
    </Routes>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 0.95 }}>
      <CartProvider>
        <CustomerAuthProvider>
          <BrowserRouter>
            <AppRouter />
            <CartDrawer />
          </BrowserRouter>
          <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: 0 } }} />
        </CustomerAuthProvider>
      </CartProvider>
    </ReactLenis>
  );
}

export default App;
